import { render, staticRenderFns } from "./FileViewerModal.vue?vue&type=template&id=8f9355b8"
import script from "./FileViewerModal.vue?vue&type=script&lang=js"
export * from "./FileViewerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports